/* eslint-disable import/prefer-default-export */
/* eslint-disable prefer-const */
/* eslint-disable import/no-mutable-exports */
export let globalVariables = {
  refreshToken: '',
};
